/* Stockist store-locator encoding repair.
 *
 * Some store names / addresses were saved in Stockist with their UTF-8 accents
 * mis-decoded as Mac OS Roman ("mojibake"): e.g. "Montréal" renders as
 * "Montr√©al" ( √ = a radical sign that looks like a checkmark, © = copyright ).
 *
 * This reverses it: for each bit of text the widget renders, we map the shown
 * characters back to their Mac-Roman byte values, then re-decode those bytes as
 * UTF-8. Text that ISN'T mojibake fails that UTF-8 re-decode and is returned
 * untouched, so it is safe to run over everything. Scoped to the widget only.
 *
 * This is a display-level safety net. The clean permanent fix is to correct the
 * names in the Stockist dashboard (the data source).
 */
(function () {
  // Mac OS Roman, bytes 0x80–0xFF → Unicode code points (index 0 = byte 0x80).
  var MR = [
    0x00C4,0x00C5,0x00C7,0x00C9,0x00D1,0x00D6,0x00DC,0x00E1,0x00E0,0x00E2,0x00E4,0x00E3,0x00E5,0x00E7,0x00E9,0x00E8,
    0x00EA,0x00EB,0x00ED,0x00EC,0x00EE,0x00EF,0x00F1,0x00F3,0x00F2,0x00F4,0x00F6,0x00F5,0x00FA,0x00F9,0x00FB,0x00FC,
    0x2020,0x00B0,0x00A2,0x00A3,0x00A7,0x2022,0x00B6,0x00DF,0x00AE,0x00A9,0x2122,0x00B4,0x00A8,0x2260,0x00C6,0x00D8,
    0x221E,0x00B1,0x2264,0x2265,0x00A5,0x00B5,0x2202,0x2211,0x220F,0x03C0,0x222B,0x00AA,0x00BA,0x03A9,0x00E6,0x00F8,
    0x00BF,0x00A1,0x00AC,0x221A,0x0192,0x2248,0x2206,0x00AB,0x00BB,0x2026,0x00A0,0x00C0,0x00C3,0x00D5,0x0152,0x0153,
    0x2013,0x2014,0x201C,0x201D,0x2018,0x2019,0x00F7,0x25CA,0x00FF,0x0178,0x2044,0x20AC,0x2039,0x203A,0xFB01,0xFB02,
    0x2021,0x00B7,0x201A,0x201E,0x2030,0x00C2,0x00CA,0x00C1,0x00CB,0x00C8,0x00CD,0x00CE,0x00CF,0x00CC,0x00D3,0x00D4,
    0xF8FF,0x00D2,0x00DA,0x00DB,0x00D9,0x0131,0x02C6,0x02DC,0x00AF,0x02D8,0x02D9,0x02DA,0x00B8,0x02DD,0x02DB,0x02C7
  ];
  var rev = {};
  for (var i = 0; i < MR.length; i++) rev[MR[i]] = 0x80 + i;

  var decoder;
  try { decoder = new TextDecoder('utf-8', { fatal: true }); }
  catch (e) { return; } // very old browser — bail rather than risk anything

  function repair(s) {
    if (!s) return s;
    var bytes = [], changed = false;
    for (var j = 0; j < s.length; j++) {
      var cp = s.charCodeAt(j);
      if (cp < 0x80) { bytes.push(cp); }                       // plain ASCII
      else if (rev[cp] !== undefined) { bytes.push(rev[cp]); changed = true; }
      else { return s; }                                        // not Mac-Roman → not this mojibake
    }
    if (!changed) return s;
    try { return decoder.decode(new Uint8Array(bytes)); }       // valid UTF-8 → it was mojibake
    catch (e) { return s; }                                     // invalid → leave it alone
  }

  function fixNode(node) {
    if (!node || node.nodeType !== 3) return;
    var f = repair(node.nodeValue);
    if (f !== node.nodeValue) node.nodeValue = f;
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { fixNode(root); return; }
    if (root.nodeType !== 1) return;
    var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = tw.nextNode())) nodes.push(n);
    nodes.forEach(fixNode);
  }

  function boot() {
    var widget = document.querySelector('stockist-store-locator');
    if (!widget) return;
    walk(widget); // catch anything already rendered
    // The widget loads async and re-renders on search, so watch for changes.
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'characterData') fixNode(m.target);
        else for (var k = 0; k < m.addedNodes.length; k++) walk(m.addedNodes[k]);
      }
    }).observe(widget, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
